const formatSettingsParam = (settingSelected) => {
  let param = '';
  switch (settingSelected) {
    case 'appt_calendar':
      param = 'AppointmentCalendar';
    break;
    case 'courtesy_lyft':
      param = 'courtesy_lyft';
    break;
    case 'smart_promise_time':
      param = 'smart_promise_time';
    break;
    case 'readySms':
      param = 'AutomateVehicleReadySMS';
    break;
    case 'promisedSms': 
      param = 'AutomatePromisedTimeSMS';
    break;
    case 'multiple_sms':
      param = 'multiple_sms';
    break;
    case 'global_beback':
      param = 'global_beback';
    break;
    case 'promise_time_appointments':
      param = 'promise_time_appointments';
    break;
    default: break;
  }

  return param;

}

export { formatSettingsParam };